<template>
    <div class="InsDetails_wrapper">
        <header>
            <div class="first">
                <span class="header_left">保单号：</span>
                <span class="first_right">0201910152324768970073</span>
            </div>
            <div class="second">
                <span class="header_left">购买产品：</span>
                <span class="second_center">标准版</span>
                <span class="second_right">120.00元</span>
            </div>
            <div class="third">
                <span class="header_left">购买时间：</span>
                <span class="third_right">2020—8-31（李大明）</span>
            </div>
        </header>
        <section class="applicant_box">
            <div class="perImg">
                <span>被保人员</span>
                <div class="pic"></div>
            </div>
            <div class="info">
                <span>郭学丽</span>
                <div class="number">371424198008215422</div>
            </div>
        </section>
        <div class="record_box">
            <p>操作记录：</p>
            <p>将“王美丽”替换成“王二”</p>
            <p>2020-10-25 张三</p>
        </div>
        <footer>
            <div @click="changePerson" :style="changeFlag==true?{backgroundColor:'#e7e7e7'}:''">换人</div>
            <div @click="applyClaim('400-099-6778')">申请理赔</div>
        </footer>
    </div>
</template> 

<script>
import "./InsuranceDetails.less";
import { Dialog } from "vant";
export default {
    name: "InsuranceDetails",
    data() {
        return {
            changeFlag: true, // 根据返回状态决定是否可以点击换人按钮
        };
    },
    methods: {
        changePerson() {
            console.log("处理换人逻辑");
        },

        applyClaim(tel) {
            Dialog.confirm({
                // title: "标题",
                message: "是否拨打客服热线400-099-6778",
            })
                .then(() => {
                    // on confirm
                    window.location.href = "tel:" + tel;
                })
                .catch(() => {
                    // on cancel
                });
            console.log("申请理赔");
        },
    },
};
</script>

<style>
</style>